import React, {useRef, useState} from "react";
import Dialog from "@mui/material/Dialog";
import {Box} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogFormActions from "../shared/DialogFormActions";

function SttServiceProviderCreate({ provider, onClose, onSubmit }) {
    const [name, setName] = useState(provider ? provider.name : '');

    const dialogRef = useRef(null);

    const handleSubmit = e => {
        e.preventDefault();
        onSubmit({ name });
    };

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                className="core-dialog"
            >
                <Box ref={dialogRef}>
                    <DialogTitle sx={{fontWeight: 'bold'}}>{provider ? 'Edit' : 'Create'} STT Service Provider</DialogTitle>
                    <form
                        onSubmit={handleSubmit}
                        style={{display: 'contents'}}
                        className="core-form"
                    >
                        <DialogContent className="core-dialog-content">
                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    name="name"
                                    variant="standard"
                                    value={name}
                                    fullWidth
                                    onChange={e => setName(e.target.value)}
                                />
                            </div>
                        </DialogContent>
                        <DialogFormActions dialogRef={dialogRef} onClose={onClose}></DialogFormActions>
                    </form>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}

export default SttServiceProviderCreate;
